<template>

<div>
  <section v-if="!registered">
    <div class="add-device">
    <div class="container">
      <div>
        <form id="form" v-on:submit.prevent="registerDevice" >
          <div class="form-group">
            <label for="name">Name<span>*</span></label>
            <input type="text" class="form-control" placeholder="Name"  v-model="name" v-on:input="$v.name.$touch" v-bind:class="{error: $v.name.$error, valid: $v.name.$dirty && !$v.name.$invalid}">
          </div>
          <div class="form-group">
            <label for="email">Email<span>*</span></label>
            <input type="text" class="form-control" v-model="email" v-on:input="$v.email.$touch" v-bind:class="{error: $v.email.$error, valid: $v.email.$dirty && !$v.email.$invalid}">
          </div>
          <div class="form-group">
            <label for="phone no">Phone No</label>
            <input type="text" class="form-control" v-model="phone" v-on:input="$v.phone.$touch" v-bind:class="{error: $v.phone.$error, valid: $v.phone.$dirty && !$v.phone.$invalid}">
          </div>
          <div class="form-group device-type">
           <label for="device type">
            Device Type
          </label>
          <label class="male-radio  control control--radio radio-inline">
            <input name="optionsRadios" id="#" class="radio-btn" value="option1" checked="checked" type="radio" v-model="deviceType">Origins Laser Egg
            <div class="control__indicator"></div>
          </label>
          <label class="male-radio control control--radio radio-inline">
            <input name="optionsRadios" id="#" class="radio-btn" value="option2" checked="checked" type="radio" v-model="deviceType">AirVisual Node
            <div class="control__indicator"></div>
          </label>
          </div>
          <div class="form-group">
            <label for="device id">Device Id</label>
            <input type="text" class="form-control" v-model="deviceId" v-on:input="$v.deviceId.$touch" v-bind:class="{error: $v.deviceId.$error, valid: $v.deviceId.$dirty && !$v.deviceId.$invalid}">
          </div>
          <div class="form-group">
            <label for="device location">GPS Coordinates</label>
            <input type="text" class="form-control" v-model="address" v-on:input="$v.address.$touch" v-bind:class="{error: $v.address.$error, valid: $v.address.$dirty && !$v.address.$invalid}">
          </div>
          <div class="form-group">
            <label for="Height of Device">Height of Device</label>
            <input type="text" class="form-control" v-model="height_of_device">
          </div>
          <div class="form-group">
            <label for="image">Image</label>
            <input type="file" class="form-control" id="file">
          </div>
          <button type="submit" class="btn btn-default device-btn" :disabled="$v.$invalid">Register Device</button>
      </form>
    </div>
  <div class="form-group" style="margin-top:20px">
      <div class='alert alert-danger' v-if='errors.length > 0'>
          <strong>Whoops!</strong> {{inputError}}<br><br>
          <ul>
              <li v-for='error in errors'>
                  {{ error }}
              </li>
          </ul>
      </div>
  </div>
  </div>
  </div><!-- end add device -->
  </section>

  <section class="bg-color" v-if="registered">
      <div class="container">
        <div class="error-content">
         <h2>Success</h2>
         <p>Your Device was successfully registered! We will contact you soon..</p>
        </div><!-- end error-content -->
        </div>
  </section>
</div>

</template>
<script>
import {HTTP} from '../http-common.js'
// import Vue from 'vue'
// import Validations from 'vuelidate'
// import { email, required } from 'vuelidate/lib/validators'

// Vue.use(Validations)
// import { validationsMixin } from 'vuelidate'
import Vue from 'vue'
import Validations from 'vuelidate'
import { required, minLength, between,email,alphaNum,numeric } from 'vuelidate/lib/validators'
// import Multiselect from 'vue-multiselect'
  // register globally
Vue.use(Validations)

export default {
  name: 'register',
  data () {
    return {
      name: '',
      email : '',
      deviceId : '',
      phone : '',
      address : '',
      deviceType : '',
      height_of_device : '',
      options: ['Select Device', 'Egg Device', 'Air Visual'],
      errors: [],
      inputError : '',
      registered : false
    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    },
    email: {
      required,
      email
    },
    deviceId: {
      required,
      alphaNum
    },
    phone: {
      numeric
    },
    address: {
      minLength: minLength(2)
    },
    deviceType: {
      required
    }
  },
  methods: {
    registerDevice: function () {
      var vm = this
      if (!vm.$v.$invalid) {
        vm.errors = []
        var options = {
          name: vm.name,
          email: vm.email,
          device_id: vm.deviceId,
          phone: vm.phone,
          address: vm.address,
          device_type: vm.deviceType,
          height_of_device:vm.height_of_device,
          file:document.getElementById('file').files[0]
        }
        //options.append('file', document.getElementById('file').files[0]);
        //console.log(options)
        HTTP.post('register/device', options)
        .then(function (response) {
          if(response.status==200){
            vm.registered = true
          }
        })
        .catch(e => {
          if (e.response) {
            vm.error = true
            if (typeof e.response.data.errors === 'object') {
                vm.inputError = "There was problem with your input"
                $.each(e.response.data.errors, function(key, value) {
                    vm.errors.push(value)
                });
            } else {
                vm.inputError = ''
                vm.errors.push('Something went wrong. Please try again.');
            }

          } else {
            vm.errors.push('Something went wrong. Please try again.');
          }
        })
      }
    }
  }
}
</script>

<style>
/*input {
  border: 1px solid silver;
  border-radius: 4px;
  background: white;
  padding: 5px 10px;
}*/
.device-type label {
    display: inline-block;
}
.error {
  border: 1px solid red !important;
  background: #FDD;
}
</style>



// WEBPACK FOOTER //
// Register.vue?2765a31d